<template>
  <div class="welcome-text">
    <h3 v-if="teamMember" class="welcome-title">Hello, {{ `${teamMember.fname} ${teamMember.lname}` }}</h3>
    <h3 v-else class="welcome-title">Hello, {{ details.name }}</h3>
    <p class="welcome-subtitle">We're glad to have you.</p>
  </div>
</template>

<script>
import { getItem } from "@/utils/storage.js";

export default {
  name: "WelcomeText",

  data() {
    return {
      details: {},
      teamMember: null,
    };
  },

  mounted() {
    this.details = getItem("org_details");
    this.teamMember = getItem("team_member");
  },
};
</script>

<style lang="scss" scoped>
.welcome-text {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
}

.welcome-title {
  font-size: 17px;
  font-weight: 500;
  color: #0f172a;
  text-transform: capitalize;
}

.welcome-subtitle {
  font-size: 13px;
  color: #475569;
  margin-top: 2px;
}
</style>
